import { atom } from 'jotai';

import {
  IGetApiAccAccountResponse,
  IGetApiAccAccountStudentsResponse,
} from '../api/interface/account';
import { IGetApiStudentMasterV2AppPageResponse } from '../api/interface/cloud-storytelling';
import { IGetPublicOpenIpInfoV2Response } from '../api/interface/open';

export const studentListAtom = atom<IGetApiAccAccountStudentsResponse | null>(
  null,
);

export const accountAtom = atom<IGetApiAccAccountResponse | null>(null);

// 家长验证状态atom - true表示已验证，false表示未验证
export const parentVerificationStatusAtom = atom<boolean | null>(null);

export const ipInfoAtom = atom<IGetPublicOpenIpInfoV2Response | null>(null);

export const usedLanguageAtom = atom<Record<string, string>>({});

export const cloudStorytellingAtom =
  atom<IGetApiStudentMasterV2AppPageResponse | null>(null);
